import { getReactSentryConfig } from '@sequencehq/utils'

export const getSentryConfig = () =>
  getReactSentryConfig({
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT
  })
